import React from 'react';
import Icon from '../icon/Icon';
import * as S from './IconButton.styles';

type IconVariant =
  | 'primary'
  | 'secondary-1'
  | 'secondary-2'
  | 'secondary-3'
  | 'neutral'
  | 'danger'
  | 'warning'
  | 'info'
  | 'success';

type IconModifier = 'regular' | 'strong' | 'weak' | 'inverted';

type IconButtonProps = {
  /** Nombre del ícono (iconSource) */
  name: string;
  /** Texto descriptivo obligatorio para accesibilidad (WCAG 2.1 SC 4.1.2) */
  ariaLabel: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Tamaño del ícono en px. Default: 24 */
  size?: number;
  variant?: IconVariant;
  modifier?: IconModifier;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
};

const IconButton = ({
  name,
  ariaLabel,
  onClick,
  size = 24,
  variant = 'primary',
  modifier = 'regular',
  disabled = false,
  type = 'button',
}: IconButtonProps) => (
  <S.IconButton
    type={type}
    aria-label={ariaLabel}
    onClick={onClick}
    disabled={disabled}
  >
    <Icon
      name={name}
      variant={variant}
      modifier={modifier}
      width={size}
      height={size}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      disabled={disabled}
    />
  </S.IconButton>
);

export default IconButton;
